/**
 * Best Practice for performance
 * https://developers.google.com/web/tools/lighthouse/audits/passive-event-listeners
 */
// document.addEventListener('touchstart', onTouchStart, {passive: true});

/**
 * Pauses the carousel with class `mobile-carousel` when not on mobile
 */

export default (function () {
  let isCarouselPaused = true;

  $(window).on("load resize", function () {
    if (document.documentElement.clientWidth <= 768) {
      if (!isCarouselPaused) {
        $(".mobile-carousel").each(function () {
          $(this).carousel("cycle");
        });
        isCarouselPaused = false;
      }
    } else {
      if (isCarouselPaused) {
        $(".mobile-carousel").each(function () {
          $(this).carousel("pause");
        });
        isCarouselPaused = true;
      }
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    const lazyBackgrounds = document.querySelectorAll(".bh-sl-map");

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const bgElement = entry.target;
          const bgImage = bgElement.getAttribute("data-bg");
          bgElement.style.backgroundImage = `url(${bgImage})`;
          observer.unobserve(bgElement);
        }
      });
    });

    lazyBackgrounds.forEach((bg) => observer.observe(bg));
  });
})();
